import { useEffect, useState } from "react";
import Modal from "react-modal/lib/components/Modal";
import api from "../../../services/api";
import logo from "../../../assets/logosz.png";
import closeImg from "../../../assets/close.png";
import functions from "../../../util/functions";
import "./style.css";

Modal.setAppElement("#root");

function ReceiveModal(props) {
	const [loading, setLoading] = useState(true);

	const [formaPgto, setFormaPgto] = useState([]);
	const [banco, setBanco] = useState([]);
	const [contaEntrada, setContaEntrada] = useState([]);

	const [nomeCliente, setNomeCliente] = useState("");

	const [idConta, setIdConta] = useState(0);
	const [valor, setValor] = useState(0);
	const [forma, setForma] = useState("");
	const [ativo, setAtivo] = useState("");

	const [idVenda, setIdVenda] = useState(0);
	const [idContaEntrada, setIdContaEntrada] = useState(0);
	const [idUsuario, setIdUsuario] = useState(0);
	const [idCliente, setIdCliente] = useState(0);
	const [descricao, setDescricao] = useState("");
	const [dataRecebimento, setDataRecebimento] = useState("");
	const [categoria, setCategoria] = useState(0);
	const [parcelaTotal, setParcelaTotal] = useState(0);
	const [parcela, setParcela] = useState(0);
	const [fixoMensal, setFixoMensal] = useState(false);
	const [alterarTodos, setAlterarTodos] = useState(false);
	const [debitoAutomatico, setDebitoAutomatico] = useState(false);

	const [status, setStatus] = useState();
	const [statusMessage, setStatusMessage] = useState();

	useEffect(() => {
		if (props.isOpen) {
			const bd = functions.databaseConfig();

			setLoading(true);

			api.get(`v1/formapgto`, {
				headers: {
					banco: bd,
				},
			})
				.then((response) => {
					setFormaPgto(response.data);
				})

				.catch((err) => {
					setFormaPgto([]);
				})
				.then(
					api
						.get(`v1/bancos`, {
							headers: {
								banco: bd,
							},
						})
						.then((response) => {
							setBanco(response.data);
						})
						.catch((err) => {
							setBanco([]);
						})
				)
				.then(
					api
						.get(`v1/auth/contaentrada/listarid`, {
							params: {
								id: props.idContaEntrada,
							},
							headers: {
								banco: bd,
							},
						})
						.then((response) => {
							setContaEntrada(response.data);

							setForma(response.data[0].forma);
							setValor(response.data[0].valor);
							setAtivo(response.data[0].ativo);
							setNomeCliente(response.data[0].nome);
							setIdConta(response.data[0].id_conta);

							setIdVenda(response.data[0].id_venda);
							setIdContaEntrada(response.data[0].id_conta_entrada);
							setIdUsuario(response.data[0].id_funcionario);
							setIdCliente(response.data[0].id_cliente);
							setDescricao(response.data[0].descricao);
							setDataRecebimento(response.data[0].data);
							setCategoria(response.data[0].id_conta_tipo);
							setParcela(response.data[0].parcela);
							setParcelaTotal(response.data[0].parcela_total);
							setFixoMensal(response.data[0].fixomensal);
							setAlterarTodos(false);
							setDebitoAutomatico(response.data[0].movautomatica);

							setLoading(false);
						})
						.catch((err) => {
							setContaEntrada([]);
							props.message("error", "Sem resposta com o servidor. Tente Novamente");
							props.onRequestClose();
						})
				);
		}
	}, [props.isOpen]);

	useEffect(() => {
		if (ativo === "SIM") {
			setStatus(true);
			setStatusMessage("À pagar");
		} else {
			setStatusMessage("Pago");
			setStatus(false);
		}
	}, [ativo]);

	function receive() {
		if (ativo === "SIM") {
			setAtivo("NAO");
		} else if (ativo === "NAO") {
			setAtivo("SIM");
		}
	}

	function RegisterReceive() {
		const data = functions.dateByString(dataRecebimento);

		let debitoAut = false;

		if (debitoAutomatico === "S") debitoAut = true;
		const bd = functions.databaseConfig();
		api.post(
			"v1/refatorar/update",
			[
				{
					ID_VENDA: idVenda,
					ID_CONTA_ENTRADA: idContaEntrada,
					ID_USUARIO: idUsuario,
					ID_CLIENTE: idCliente,
					DESCRICAO: descricao,
					VALOR: valor,
					DATA_RECEBIMENTO: data,
					CATEGORIA: categoria,
					CONTA: idConta,
					PARCELAS: parcelaTotal,
					FORMA: forma,
					ATIVO: ativo,
					FIXOMENSAL: fixoMensal,
					FMALTERARTODOS: alterarTodos,
					DEBITOAUTOMATICO: debitoAut,
				},
			],
			{
				headers: {
					banco: bd,
				},
			}
		)
			.then((response) => {
				props.listar();
				if (response.request.status == 200 || response.request.status == 201) {
					props.message("success");

					props.onRequestClose();
				} else {
					props.message("error", `Erro ao salvar, ${response.request.response}`);
				}
			})
			.catch((err) => {
				if (err.response) {
					props.message("error", `Erro ao salvar, ${err.response.response}`);
				} else {
					props.message("error", "Verifique os dados e tente novamente");
					// setVerificacoes(false);
					props.onRequestClose();
				}
			});
	}

	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.onRequestClose}
			overlayClassName="react-modal-overlay"
			className="react-modal-content"
		>
			<div className="logo-forms">
				<img className="logo-forms-img" src={logo} alt="" />
			</div>
			<button type="button" onClick={props.onRequestClose} className="react-modal-close">
				<img src={closeImg} alt="Fechar" />
			</button>

			<div className="container-fluid h-100 receive">
				{!loading ? (
					<>
						<div className="col-12 mt-3">
							<div className="d-flex justify-content-between">
								<h3>Recebimentos...</h3>
							</div>
							<div className="d-flex justify-content-between align-itens-center">
								<div>
									<small className="text-secondary">Cliente</small>
									<h5>{nomeCliente}</h5>
								</div>
								<div>
									<small className="text-secondary">ID Conta</small>
									<h5>{idContaEntrada}</h5>
								</div>
								<div>
									<small className="text-secondary">Parcela</small>
									<h5>{`${parcela}/${parcelaTotal}`}</h5>
								</div>
							</div>
						</div>

						<div className="row"></div>
						<div className="d-flex align-itens-center">
							<div className="col-3">
								<small className="text-secondary">Valor</small>
								<h5>{valor}</h5>
							</div>
							<div className="col-9 form-check form-switch d-flex justify-content-end align-items-center mt-3">
								<input
									className="form-check-input"
									type="checkbox"
									role="switch"
									id="flexSwitchCheckDefault"
									checked={status}
									onChange={(e) => receive()}
								/>
								<label className="form-check-label ms-3" htmlFor="flexSwitchCheckDefault">
									{statusMessage}
								</label>
							</div>
						</div>

						<div className="mb-3">
							{/* <select name="cidades" id="cidades" className="form-select" onChange={SalvarCidade} value={codCidade} ref={selectCidade} required> */}

							<small className="text-secondary">Forma Pagamento</small>
							<select
								name="cidades"
								id="cidades"
								className="form-select"
								onChange={(e) => setForma(e.target.value)}
								value={forma}
								required
							>
								<option value="0000000">Forma de Pgto</option>
								{formaPgto.map((c) => {
									return (
										<option key={c.nome} value={c.nome}>
											{c.nome}
										</option>
									);
								})}
							</select>
							<div className="valid-feedback">Validado!</div>
							<div className="invalid-feedback">Por favor escolha a forma de pagamento</div>
						</div>

						<div className="mb-3">
							<small className="text-secondary">Banco</small>
							<select
								name="cidades"
								id="cidades"
								className="form-select"
								onChange={(e) => setIdConta(e.target.value)}
								value={idConta}
								required
							>
								<option value="0000000">Banco</option>
								{banco.map((c) => {
									return (
										<option key={c.id_conta} value={c.id_conta}>
											{c.banco}
										</option>
									);
								})}
							</select>
							<div className="valid-feedback">Validado!</div>
							<div className="invalid-feedback">Por favor escolha a forma de pagamento</div>
						</div>

						<div className="row mb-3">
							<div className="col-12 mt-3 d-flex justify-content-end align-items-center">
								<button
									type="button mt-3"
									onClick={(e) => RegisterReceive()}
									className="btn btn-lg btn-outline-primary"
								>
									Salvar
								</button>
							</div>
						</div>
					</>
				) : (
					<div className="loading text-center h-100 m-5">
						<div>
							<span className="spinner-grow spinner-grow-sm text-primary me-2" role="status"></span>
							<span className="text-primary">Buscando Dados...</span>
						</div>
					</div>
				)}
			</div>
		</Modal>
	);
}

export default ReceiveModal;
